
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Template } from "@/types/template";
import { useEffect } from "react";
import { TemplateContent } from "@/components/template/TemplateContent";
import "@/styles/TemplateDocument.css";

interface ProcessedTemplateDialogProps {
  template: Template;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProcessedTemplateDialog({
  template,
  open,
  onOpenChange,
}: ProcessedTemplateDialogProps) {
  // Prevent keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (open && (e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'C')) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open]);

  // Prevent right-click context menu
  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    return false;
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent 
        className="max-w-4xl max-h-[80vh] overflow-y-auto"
        onContextMenu={handleContextMenu}
      >
        <DialogHeader>
          <DialogTitle>{template.filename}</DialogTitle>
        </DialogHeader>
        <div className="mt-4 select-none">
          <TemplateContent 
            content={template.processed_html || 'No processed content available'}
            displayAsForm={false}
        />
        </div>
      </DialogContent>
    </Dialog>
  );
}
